import $axios from "@/api";

const state = () => ({
    data: {
        typePayment:[],
        driverPayment: [],
    },
})

const mutations = {
    ASSIGN_DATA(state,payload){
        state.data[payload.target] = payload.data
    },
}

const groupUrl = "detail_pelunasan_driver"
const actions = {
    async getDriverPayment({ commit }, filter) {
        try{
            const response =  await $axios.get(`${groupUrl}`,{params:filter})
            commit('ASSIGN_DATA',{data:response.data.data,target:'driverPayment'})
        }catch(error){
            console.log(error)
        }
    },

    async getTypePayment({ commit }, filter) {
        try{
            const response =  await $axios.get(`${groupUrl}/payment-type-list`)
            commit('ASSIGN_DATA',{data:response.data,target:'typePayment'})
        }catch(error){
            console.log(error)
        }
    },

    async updatePayment({state}, payload) {
        try{
            const response =  await $axios.put(`${groupUrl}/${payload.id_payment}`, payload)
            return response.data.message
        }catch(error){
            console.log(error)
        }
    },

    async deletePayment({state}, payload) {
        try{
            const response =  await $axios.delete(`${groupUrl}/${payload.id_payment}`)
            return response.data.message
        }catch(error){
            console.log(error)
        }
    },

    async unapprovePayment({state }, payload) {
        try{
            const response =  await $axios.put(`${groupUrl}/${payload.id_payment}/unapprove`)
            return response.data.message
        }catch(error){
            console.log(error)
        }
    },

    async bulkApprove({state }, payload) {
        try{
            const response =  await $axios.put(`${groupUrl}/approve`, payload)
            return response.data.message
        }catch(error){
            console.log(error)
        }
    },
    async bulkReject({state}, payload) {
        try{
            const response =  await $axios.put(`${groupUrl}/reject`, payload)
            return response.data.message
        }catch(error){
            console.log(error)
        }
    }

}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
